import { render } from "./KitchenLayout.vue?vue&type=template&id=a9bdb0f0"
import script from "./KitchenLayout.vue?vue&type=script&lang=js"
export * from "./KitchenLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__